export default __webpack_public_path__ + "images/p4.jpg";